import markdownit from 'markdown-it';

const md = markdownit();
md.set({ linkify: true });
md.disable(['image']);
const defaultRender =
  md.renderer.rules.link_open ||
  function renderSelf(tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
  };

md.renderer.rules.link_open = function renderWithTarget(tokens, idx, options, env, self) {
  const url = tokens[idx].attrs[0][1];
  const isInternalLink = /^(https?:\/\/)?(www.)?shop.telekom.de/i.test(url);
  if (!isInternalLink) {
    tokens[idx].attrPush(['target', '_blank']); // add new attribute
    tokens[idx].attrPush(['rel', 'noopener']); // add new attribute
  }

  // pass token to default renderer.
  return defaultRender(tokens, idx, options, env, self);
};

export default (src) => md.renderInline(src);
